import { AxiosResponse, AxiosRequestConfig } from 'axios';
import client from 'api/client';
import { CandidateInfo } from '../models/response';

export function get(
    candidate_id: string,
    role: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<CandidateInfo>> {
    return client.get<CandidateInfo>(`/set_client_role/${candidate_id}/${role}`, customConfig);
}
